<template>
    <div class="repairer-rfqs-page">
        <div class="page-header">
          <div class="d-flex justify-content-between">
            <div class="">
              <h4>Request for Quotes</h4>
              <ol class="breadcrumbs">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'RepairerDashboard'}">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">View Quotes</li>
              </ol>
            </div>
            <div class="float-right search-filter-in-header">
              <search-filter
                  type="estimates"
                  v-model="searchFilter2"
                  :limitLength="50"
                  :filterValue="searchFilter2"
                  @selectAdditional="redirectToRfqView"
                  @onEnter="onEnter"
                  :placeholder="'Search'"
                  :additionalMenu="additionalMenu"
                  :isSearch="true"
                  :debug="false"
                  height="41px"
                  aria-expanded="false"
                  data-toggle="dropdown"
              />
            </div>
          </div>
            <div class="page-header-nav-btn">
                <a @click="clickSubmitQuote" class="btn btn-primary btn-submit-quote" v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Start your Request for a Parts quote', placement:'left'}">
                    <i class='bx bx-plus'></i><span>Submit Quote</span>
                </a>
            </div>
        </div>
        <div class="repairer-rfqs-body">
            <tabs ref="repairer-rfqs-table" @changed="tabChanged" cache-lifetime="0" :options="{useUrlFragment:true}" :custom-counts="computedTotalCounts">
                <tab name="All" id="all" :class-name="'tab-content-table'">
                  <div class="use-pagination-block-bottom">
                    <b-table
                        responsive
                        hover
                        :items="pagedAllRFQs"
                        :fields="computedAllFields"
                        :sort-by="sortByAll"
                        :sort-desc="sortDescAll"
                        @sort-changed="onSortChanged('All', $event)"
                        @row-clicked="clickRFQRow"
                        @row-contextmenu="openMenuForRFQs"
                    >
                      <template #cell(bidders)="data">
                        <div class="">
                                <span  v-for="(bidder, ind) in data.value" :key="ind">
                                    <i v-if="!(((bidder.status === 'Declined') || (bidder.status === 'Priced' && bidder.isUpdatedPrices)) && !isShowBidders)"
                                       style="font-size: 23px"
                                       :class="{
                                       'bx bx-minus-circle bidder-color-orange': bidder.status === 'Nil Stock',
                                       'bx bxs-badge-dollar': bidder.status !== 'Nil Stock',
                                       'bidder-color-gray': (bidder.status === 'Not Priced' && data.item?.status === 'Submitted'),
                                       'bidder-color-orange': (bidder.status === 'Not Priced' && data.item?.status !== 'Submitted'),
                                       'bidder-color-red red-icon-blinker': bidder.status === 'Declined',
                                       'bidder-color-green': bidder.status === 'Priced',
                                     }"
                                       v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title: getBidderTooltipCached(bidder, data.item), placement:'leftbottom'}"
                                    ></i>
                                    <i
                                        v-else
                                        class='bx bxs-badge-dollar'
                                        style="font-size: 23px; color: white"
                                    ></i>
                                  </span>
                        </div>
                      </template>
                      <template v-slot:cell(images)="data">
                        <img v-if="getImageUrl(data)" style="width: 60px; height: 60px; object-fit: cover;" :src="getImageUrl(data)" alt="">
                      </template>
                      <template v-slot:cell(assignedTo)="data">
                        <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                      </template>
                      <template v-slot:head()="data">
                        <div v-if="!data.field.sortable">{{data.label}}</div>
                        <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                      </template>
                      <template #cell(dateSubmitted)="data">
                        {{ data.value | formatDate }}
                      </template>
                      <template #cell(dateDue)="data">
                        <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br v-if="data.value"/></span>
                        {{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}
                      </template>
                      <template #cell(quoteCompletion)="data">
                        <template v-if="data?.item?.status === 'Submitted' || data?.item?.status === 'Priced'">
                        {{ data.value}}
                          </template>
                        <template v-else>
                        </template>
                      </template>
                      <template v-slot:cell(notifications)="data">
                        <notificationOnTable
                            :isBlinkingOrangeIcon="isBlinkingOrangeIcon(data.item)"
                            :isBiddersBlinking="isShowBidders"
                            :items="data">
                        </notificationOnTable>
                      </template>
                    </b-table>
                  </div>
                  <block-pagination
                      :role="'RFQs'"
                      :count="gettersAllRFQs.length"
                      :countFiltered="filter ? filteredAllRFQs.length : computedAllRFQs.length"
                      :currentPage="getterAllRFQsCurrentPage"
                      @changedCurrentPage="changedCurrentPageAll"
                      :perPage="getterPerPageAll"
                      @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPageAll', value)"
                  >
                  </block-pagination>
                </tab>
                <tab v-if="!isStatewide" name="Received" id="received" :class-name="'tab-content-table'">
                    <div class="use-pagination-block-bottom">
                        <b-table
                                responsive
                                hover
                                :items="pagedReceivedRFQs"
                                :fields="computedReceivedFields"
                                :sort-by="sortByReceived"
                                :sort-desc="sortDescReceived"
                                @sort-changed="onSortChanged('Received', $event)"
                                @row-clicked="clickRFQRow"
                                @row-contextmenu="openMenuForRFQs"
                        >
                            <template v-slot:cell(images)="data">
                              <img v-if="getImageUrl(data)" style="width: 60px; height: 60px; object-fit: cover;" :src="getImageUrl(data)" alt="">
                            </template>
                            <template v-slot:cell(assignedTo)="data">
                              <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                            </template>
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template #cell(dateReceived)="data">
                                {{ data.value | formatDate }}
                            </template>
                            <template #cell(dateDue)="data">
                                <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br v-if="data.value"/></span>
                                <span v-if="data.value.includes('1970-01-01')"></span>
                                <span v-else>
                                  {{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}
                                </span>
                            </template>
                            <template v-slot:cell(notifications)="data">
                                <notificationOnTable
                                    :isBiddersBlinking="true"
                                        :items="data">
                                </notificationOnTable>
                            </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'RFQs'"
                        :count="gettersReceivedRFQs.length"
                        :countFiltered="filter ? filteredReceivedRFQs.length : computedReceivedRFQs.length"
                        :currentPage="getterReceivedRFQsCurrentPage"
                        @changedCurrentPage="value => $store.commit('repairer/rfq/repairerRFQReceivedCurrentPage', value)"
                        :perPage="getterPerPage"
                        @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPage', value)"
                    >
                    </block-pagination>

                </tab>
                <tab name="Submitted" id="submitted" :class-name="'tab-content-table'">
                    <div class="use-pagination-block-bottom">
                        <b-table
                                responsive
                                hover
                                :items="pagedSubmittedRFQs"
                                :fields="computedSubmittedFields"
                                :sort-by="sortBySubmitted"
                                :sort-desc="sortDescSubmitted"
                                @sort-changed="onSortChanged('Submitted', $event)"
                                @row-clicked="clickRFQRow"
                                @row-contextmenu="openMenuForRFQs"
                        >
                          <template #cell(bidders)="data">
                            <div class="">

                              <span  v-for="(bidder, ind) in data.value" :key="ind">
                                  <i v-if="!(((bidder.status === 'Declined') || (bidder.status === 'Priced' && bidder.isUpdatedPrices)) && !isShowBidders)"
                                     style="font-size: 23px"
                                     :class="{
                                     'bx bx-minus-circle bidder-color-orange': bidder.status === 'Nil Stock',
                                     'bx bxs-badge-dollar': bidder.status !== 'Nil Stock',
                                     'bidder-color-gray': bidder.status === 'Not Priced',
                                     'bidder-color-red red-icon-blinker': bidder.status === 'Declined',
                                     'bidder-color-green': bidder.status === 'Priced',
                                   }"
                                     v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title: getBidderTooltipCached(bidder, data.item), placement:'leftbottom'}"
                                  ></i>
                                  <i
                                      v-else
                                      class='bx bxs-badge-dollar'
                                      style="font-size: 23px; color: white"
                                  ></i>
                                </span>
                            </div>
                          </template>
                            <template v-slot:cell(images)="data">
                              <img v-if="getImageUrl(data)" style="width: 60px; height: 60px; object-fit: cover;" :src="getImageUrl(data)" alt="">
                            </template>
                            <template v-slot:cell(assignedTo)="data">
                              <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                            </template>
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template #cell(dateSubmitted)="data">
                                {{ data.value | formatDate }}
                            </template>
                            <template #cell(dateDue)="data">
                              <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br v-if="data.value"/></span>
                                {{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}
                            </template>
                            <template v-slot:cell(notifications)="data">
                                <notificationOnTable
                                    :isBlinkingOrangeIcon="isBlinkingOrangeIcon(data.item)"
                                    :isBiddersBlinking="isShowBidders"
                                    :items="data">
                                </notificationOnTable>
                            </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'RFQs'"
                        :count="gettersSubmittedRFQs.length"
                        :countFiltered="filter ? filteredSubmittedRFQs.length : computedSubmittedRFQs.length"
                        :currentPage="getterSubmittedRFQsCurrentPage"
                        @changedCurrentPage="changedCurrentPageSubmitted"
                        :perPage="getterPerPage"
                        @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPage', value)"
                    >
                    </block-pagination>
                </tab>
                <tab name="Priced" id="priced" :class-name="'tab-content-table'">
                    <div class="use-pagination-block-bottom">
                        <b-table
                                responsive
                                hover
                                :items="pagedPricedRFQs"
                                :fields="computedPricedFields"
                                :sort-by="sortByPriced"
                                :sort-desc="sortDescPriced"
                                @sort-changed="onSortChanged('Priced', $event)"
                                @row-clicked="clickRFQRow"
                                @row-contextmenu="openMenuForRFQs"
                        >
                            <template #cell(bidders)="data">
                              <div class="">
                                <span  v-for="(bidder, ind) in data.value" :key="ind">
                                  <i v-if="!(((bidder.status === 'Declined') || (bidder.status === 'Priced' && bidder.isUpdatedPrices)) && !isShowBidders)"
                                     style="font-size: 23px"
                                     :class="{
                                      'bx bx-minus-circle bidder-color-orange': bidder.status === 'Nil Stock',
                                     'bx bxs-badge-dollar': bidder.status !== 'Nil Stock',
                                     'bidder-color-orange': bidder.status === 'Not Priced',
                                     'bidder-color-red red-icon-blinker': bidder.status === 'Declined',
                                     'orange-icon orange-icon-blinker': bidder.status === 'Priced' && bidder.isSentUpdateRequested,
                                     'bidder-color-green': bidder.status === 'Priced',
                                     'green-icon-blinker': bidder.status === 'Priced' && bidder.isUpdatedPrices,
                                   }"
                                     v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title: getBidderTooltipCached(bidder, data.item), placement:'leftbottom'}"
                                  ></i>
                                  <i
                                      v-else
                                      class='bx bxs-badge-dollar'
                                      style="font-size: 23px; color: white"
                                  ></i>
                                </span>
                              </div>
                            </template>
                            <template v-slot:cell(images)="data">
                              <img v-if="getImageUrl(data)" style="width: 60px; height: 60px; object-fit: cover;" :src="getImageUrl(data)" alt="">
                            </template>
                            <template v-slot:cell(assignedTo)="data">
                              <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                            </template>
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template #cell(dateSubmitted)="data">
                                {{ data.value | formatDate }}
                            </template>
                            <template #cell(dateDue)="data">
                              <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br v-if="data.value || isSentRequest(data.item)"/></span>
                              <span v-if="isSentRequest(data.item)"  class="orange-icon" :class="{'orange-icon-blinker': isShowBidders}">UPDATE RFQ <br v-if="data.value"/></span>
                                {{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}
                            </template>
                            <template v-slot:cell(notifications)="data">
                                <notificationOnTable
                                        :isBiddersBlinking="isShowBidders"
                                        :items="data">
                                </notificationOnTable>
                            </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'RFQs'"
                        :count="gettersPricedRFQs.length"
                        :countFiltered="filter ? filteredPricedRFQs.length : computedPricedRFQs.length"
                        :currentPage="getterPricedRFQsCurrentPage"
                        @changedCurrentPage="changedCurrentPagePriced"
                        :perPage="getterPerPage"
                        @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPage', value)"
                    >
                    </block-pagination>
                </tab>
                <tab name="Ordered" id="ordered" :class-name="'tab-content-table'">
                    <div class="use-pagination-block-bottom">
                        <b-table
                                responsive
                                hover
                                :items="pagedOrderedRFQs"
                                :fields="computedOrderedFields"
                                :sort-by="sortByOrdered"
                                :sort-desc="sortDescOrdered"
                                @sort-changed="onSortChanged('Ordered', $event)"
                                @row-clicked="clickRFQRow"
                                @row-contextmenu="openMenuForRFQs"
                        >
                          <template #cell(bidders)="data">
                            <div class="">

                                <span  v-for="(bidder, ind) in data.value" :key="ind">
                                    <i v-if="!(((bidder.status === 'Declined') || (bidder.status === 'Priced' && bidder.isUpdatedPrices)) && !isShowBidders)"
                                       style="font-size: 23px"
                                       :class="{
                                       'bx bx-minus-circle bidder-color-orange': bidder.status === 'Nil Stock',
                                       'bx bxs-badge-dollar': bidder.status !== 'Nil Stock',
                                       'bidder-color-orange': bidder.status === 'Not Priced',
                                       'bidder-color-red red-icon-blinker': bidder.status === 'Declined',
                                       'bidder-color-green': bidder.status === 'Priced',
                                     }"
                                       v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title: getBidderTooltipCached(bidder, data.item), placement:'leftbottom'}"
                                    ></i>
                                    <i
                                        v-else
                                        class='bx bxs-badge-dollar'
                                        style="font-size: 23px; color: white"
                                    ></i>
                                  </span>
                            </div>
                          </template>
                            <template v-slot:cell(images)="data">
                              <img v-if="getImageUrl(data)" style="width: 60px; height: 60px; object-fit: cover;" :src="getImageUrl(data)" alt="">
                            </template>
                            <template v-slot:cell(assignedTo)="data">
                              <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                            </template>
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template #cell(dateSubmitted)="data">
                                {{ data.value | formatDate }}
                            </template>
                            <template #cell(dateDue)="data">
                              <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br /></span>
                              <span v-if="data.value">{{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}</span>
                              <span v-else>Next available run</span>
                            </template>
                            <template v-slot:cell(orderNumbers)="data">
                                <div v-bind:key="'ordNbrs'+data.item.id+index" v-for="(ord,index) in data.item.orderNumbers">{{ord}}</div>
                            </template>
                            <template v-slot:cell(notifications)="data">
                                <notificationOnTable
                                    :isBiddersBlinking="true"
                                        :items="data">
                                </notificationOnTable>
                            </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'RFQs'"
                        :count="gettersOrderedRFQs.length"
                        :countFiltered="filter ? filteredOrderedRFQs.length : computedOrderedRFQs.length"
                        :currentPage="getterOrderedRFQsCurrentPage"
                        @changedCurrentPage="changedCurrentPageOrdered"
                        :perPage="getterPerPage"
                        @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPage', value)"
                    >
                    </block-pagination>
                </tab>
                <tab name="Cancelled" id="cancelled" :class-name="'tab-content-table'">
                    <div class="use-pagination-block-bottom">
                        <b-table
                                responsive
                                hover
                                :items="pagedCancelledRFQs"
                                :fields="computedCancelledFields"
                                :sort-by="sortByCancelled"
                                :sort-desc="sortDescCancelled"
                                @sort-changed="onSortChanged('Cancelled', $event)"
                                @row-contextmenu="openMenuForRFQs"
                                @row-clicked="clickRFQRow"
                        >
                            <template v-slot:cell(assignedTo)="data">
                              <span v-if="data.value && data.value.id > 0">{{ data.value.name }}</span>
                            </template>
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template #cell(dateReceived)="data">
                                {{ data.value | formatDate }}
                            </template>
                            <template #cell(dateDue)="data">
                              <span v-if="data && data.item && data.item.isSentAsDirectOrder">DIRECT ORDER<br v-if="data.value"/></span>
                                {{ data.value | formatDate('DD/MM/YYYY || hh:mmA') }}
                            </template>
                            <template v-slot:cell(notifications)="data">
                                <notificationOnTable
                                    :isBiddersBlinking="true"
                                        :items="data">
                                </notificationOnTable>
                            </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'RFQs'"
                        :count="gettersCancelledRFQs.length"
                        :countFiltered="filter ? filteredCancelledRFQs.length : computedCancelledRFQs.length"
                        :currentPage="getterCancelledRFQsCurrentPage"
                        @changedCurrentPage="value => $store.commit('repairer/rfq/repairerRFQCancelledCurrentPage', value)"
                        :perPage="getterPerPage"
                        @changedPerPage="value => $store.commit('repairer/rfq/repairerPerPage', value)"
                    >
                    </block-pagination>
                </tab>
                <template slot="nav-item-right">
                    <div class="tabs-nav-right-search">
                      <search-filter
                          type="estimates"
                          v-model="searchFilter"
                          :filters="computedSearchFilters"
                          :limitLength="50"
                          :filterValue="filter"
                          @change="onSearchFilterChange"
                          @input="onSearchFilterInput"
                          :placeholder="'Filter By'"
                          :isShowSearIcon="false"
                          @updateToken="value => $store.commit('repairer/rfq/setToken', value)"
                          :tokenCopy="computedToken"
                          :debug="false"
                          height="41px"
                          aria-expanded="false"
                          data-toggle="dropdown"
                      />
<!--                        <b-form-input v-model="filter" type="text" class="search-input" placeholder="Search or Filter results"-->
<!--                                      debounce="500"></b-form-input>-->
                    </div>
                    <div class="tabs-nav-right-btn ml-4">
                        <a @click="clickSubmitQuote" class="btn btn-primary btn-submit-quote" v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'Start your Request for a Parts quote', placement:'leftbottom'}">
                            <i class='bx bx-plus'></i><span>Submit Quote</span>
                        </a>
                    </div>
                </template>
            </tabs>
        </div>

      <vue-context ref="menuRFQs"
                   style="width: 140px"
                   :lazy="true"
                   @close="contextClose"
                   @open="contextOpen"
                   :closeOnScroll="true">
        <template slot-scope="item">
          <b-button-toolbar key-nav>
            <b-button-group vertical style="width: 140px" class="parts-order-view__context-menu">
              <template  v-if="item && item.data && item.data.row">
                <b-button
                    class="text-left font-12 font-inter--semibold"
                    variant="outline-primary"
                    block
                    @click="viewRFQ(item.data.row)"
                > View RFQ
                </b-button>
                <b-button
                    class="text-left font-12 font-inter--semibold"
                    variant="outline-primary"
                    block
                    @click="openInNewTab(item.data.row.id)"
                >Open in New Tab
                </b-button>

                <div
                    @mouseover="isOpenSecondContextLevel = true"
                    @mouseleave="isOpenSecondContextLevel = false"
                    style="width:100%"
                >
                  <b-button
                      class="text-left font-12 font-inter--semibold d-flex align-items-center justify-content-between pr-0"
                      variant="outline-primary" block
                  >
                    Assign To
                    <i style="font-size: 20px;" class="bx bx-chevron-right text-right"></i>
                  </b-button>
                  <div v-if="isOpenSecondContextLevel" class="users-context-level">
                    <b-button v-for="user in computedUsersForAssignedFiltered(item.data.row)"
                              @click="clickOnAssignedTo(item.data.row, user)"
                              :key="'assigned-to-'+user.id"
                              class="text-left font-12 font-inter--semibold"
                              variant="outline-primary" block>{{ user.name }}
                    </b-button>
                  </div>
                </div>

                <template v-if="currentTab === 'Cancelled' || currentTab === 'Received'">
                  <b-button
                      class="text-left font-12 font-inter--semibold"
                      variant="outline-primary"
                      block
                      @click="deleteQuote(item.data.row.id)"
                  >Delete Quote
                  </b-button>
                </template>

                <template v-if="currentTab === 'Submitted' || currentTab === 'Priced'">
                  <b-button
                      class="text-left font-12 font-inter--semibold"
                      variant="outline-primary"
                      block
                      @click="cancelQuote(item.data.row.id)"
                  >Cancel Quote
                  </b-button>
                </template>

              </template>
            </b-button-group>
          </b-button-toolbar>
        </template>
      </vue-context>

    </div>
</template>
<script>
    /*eslint-disable */
    import {mapGetters, mapActions} from 'vuex';
    import notificationOnTable from "@/components/notification-on-table.vue";
    import dayjs from "dayjs";
    import Vue from "vue";
    import BlockPagination from '../../../components/utility/block-pagination';
    import SearchFilter from '../../../components/utility/search-filter/search-filter';
    import { VueContext } from 'vue-context'
    import Axios from "axios";
    import _ from "lodash";

    export default {
        name: 'rfqs',
        data: function () {
            return {
                currentTab: '',
                contextOpenEvent: null,
                isOpenSecondContextLevel: false,
                isShowBidders: false,
                _bidderTooltipCache: {},
                _debouncedSetFilter: null,
                _debouncedSearchFilter2: null,
                _searchFiltersCacheKey: '',
                _searchFiltersCacheValue: null,
                _qpIndexCacheKey: '',
                _qpIndexCacheValue: null,
                // filter: '',
                searchFilter: '',
                searchFilter2: '',
                searchFilter2Debounced: '',
                perPage: 20,
                currentPage: 1,
                sortByByTab: {
                  All: 'dateReceived',
                  Received: 'dateReceived',
                  Submitted: 'number',
                  Priced: 'number',
                  Ordered: 'number',
                  Cancelled: 'number',
                },
                sortDescByTab: {
                  All: true,
                  Received: true,
                  Submitted: true,
                  Priced: true,
                  Ordered: true,
                  Cancelled: true,
                },
              allFields: [
                {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable ', thClass: ''},
                {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable', thClass: ''},
                {label: "Make", key: "make", sortable: true, tdClass: 'clickable  number', thClass: ''},
                {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable', thClass: 'notification-column'},
                {label: "Date Submitted", key: "dateSubmitted", sortable: true, tdClass: 'clickable', thClass: ''},
                {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable number', thClass: ''},
                {label: 'Bidders', key: 'bidders', sortable: false, tdClass: 'clickable number bidders-item', thClass: 'bidders-item'},
                {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable', thClass: ''},
                {label: "Quote Completion", key: "quoteCompletion", sortable: true, tdClass: 'clickable', thClass: ''},
              ],
                receivedFields: [
                  {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable ', thClass: ''},
                  {label: "Make", key: "make", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable ', thClass: 'notification-column'},
                  {label: "Date Received", key: "dateReceived", sortable: true, tdClass: 'clickable ', thClass: ''},
                  {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable number', thClass: ''},
                ],
                submittedFields: [
                  {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable ', thClass: ''},
                  {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Make", key: "make", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable', thClass: 'notification-column'},
                  {label: "Date Submitted", key: "dateSubmitted", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: 'Bidders', key: 'bidders', sortable: false, tdClass: 'clickable number bidders-item', thClass: 'bidders-item'},
                  {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Quote Completion", key: "quoteCompletion", sortable: true, tdClass: 'clickable', thClass: ''},
                ],
                pricedFields: [
                  {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable ', thClass: ''},
                  {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Make", key: "make", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable', thClass: 'notification-column'},
                  {label: "Date Submitted", key: "dateSubmitted", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: 'Bidders', key: 'bidders', sortable: false, tdClass: 'clickable number bidders-item', thClass: 'bidders-item'},
                  {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Quote Completion", key: "quoteCompletion", sortable: true, tdClass: 'clickable', thClass: ''},
                ],
                orderedFields: [
                  {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable ', thClass: ''},
                  {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Order Nbr", key: "orderNumbers", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Make", key: "make", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable', thClass: 'notification-column'},
                  {label: "Date Submitted", key: "dateSubmitted", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable number', thClass: ''},
                  {label: 'Bidders', key: 'bidders', sortable: false, tdClass: 'clickable number bidders-item', thClass: 'bidders-item'},
                  {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                  {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable  number', thClass: ''},
                  {label: "Cost", key: "costStr", sortable: true, tdClass: 'clickable order-cost text-right number', thClass: ''},
                ],
                cancelledFields: [
                    {label: "Request Nbr", key: "number", sortable: true, tdClass: 'clickable', thClass: ''},
                    {label: "Quoting Package Nbr", key: "QPNumber", sortable: true, tdClass: 'clickable number', thClass: ''},
                    {label: "Car Rego", key: "rego", sortable: true, tdClass: 'clickable ', thClass: ''},
                    {label: "Make", key: "make", sortable: true, tdClass: 'clickable  number', thClass: ''},
                    {label: "Model", key: "model", sortable: true, tdClass: 'clickable number', thClass: ''},
                    {label: "Notifications", key: "notifications", sortable: false, tdClass: 'clickable ', thClass: 'notification-column'},
                    {label: "Date Received", key: "dateReceived", sortable: true, tdClass: 'clickable ', thClass: ''},
                    {label: "Due Date : Time", key: "dateDue", sortable: true, tdClass: 'clickable  number', thClass: ''},
                    {label: "Created By", key: "createdBy", sortable: true, tdClass: 'clickable', thClass: ''},
                    {label: "Assigned To", key: "assignedTo", sortable: true, tdClass: 'clickable  number', thClass: ''},
                ],
            };
        },
        created() {
            this._debouncedSetFilter = _.debounce((value) => {
                this.setFilter(value);
            }, 200)

            this._debouncedSearchFilter2 = _.debounce((value) => {
                this.searchFilter2Debounced = value
            }, 200)
        },
        methods: {
            ...mapActions({
                setFilter: 'repairer/rfq/setFilter'
            }),
            _mapQpLabel(fields) {
              return _.map(fields, (field) => {
                if (field && field.key === 'QPNumber' && this.isStatewide) {
                  return {
                    ...field,
                    label: 'Job Number'
                  }
                }
                return field
              })
            },
            _tabNameToId(tabName) {
              if (!tabName) {
                return 'all'
              }
              if (tabName === 'All') return 'all'
              if (tabName === 'Received') return 'received'
              if (tabName === 'Submitted') return 'submitted'
              if (tabName === 'Priced') return 'priced'
              if (tabName === 'Ordered') return 'ordered'
              if (tabName === 'Cancelled') return 'cancelled'
              return 'all'
            },
            _saveRfqListUiState() {
              try {
                const state = {
                  activeTabId: this._tabNameToId(this.currentTab),
                  perPage: this.getterPerPage,
                  perPageAll: this.getterPerPageAll,
                  pages: {
                    all: this.getterAllRFQsCurrentPage,
                    received: this.getterReceivedRFQsCurrentPage,
                    submitted: this.getterSubmittedRFQsCurrentPage,
                    priced: this.getterPricedRFQsCurrentPage,
                    ordered: this.getterOrderedRFQsCurrentPage,
                    cancelled: this.getterCancelledRFQsCurrentPage,
                  }
                }
                localStorage.setItem('repairer_rfqs_ui_state', JSON.stringify(state))
              } catch (e) {
              }
            },
            _restoreRfqListUiState() {
              try {
                const raw = localStorage.getItem('repairer_rfqs_ui_state')
                if (!raw) {
                  return null
                }
                const st = JSON.parse(raw)
                if (!st || typeof st !== 'object') {
                  return null
                }

                if (st.perPageAll != null) {
                  this.$store.commit('repairer/rfq/repairerPerPageAll', st.perPageAll)
                }
                if (st.perPage != null) {
                  this.$store.commit('repairer/rfq/repairerPerPage', st.perPage)
                }

                const pages = st.pages || {}
                if (pages.all != null) this.$store.commit('repairer/rfq/repairerRFQAllCurrentPage', pages.all)
                if (pages.received != null) this.$store.commit('repairer/rfq/repairerRFQReceivedCurrentPage', pages.received)
                if (pages.submitted != null) this.$store.commit('repairer/rfq/repairerRFQSubmittedCurrentPage', pages.submitted)
                if (pages.priced != null) this.$store.commit('repairer/rfq/repairerRFQPricedCurrentPage', pages.priced)
                if (pages.ordered != null) this.$store.commit('repairer/rfq/repairerRFQOrderedCurrentPage', pages.ordered)
                if (pages.cancelled != null) this.$store.commit('repairer/rfq/repairerRFQCancelledCurrentPage', pages.cancelled)

                return st
              } catch (e) {
                return null
              }
            },
            redirectToRfqView(itm) {
              if (itm.isJobView) {
                this.setFilter('')
                this.$router.push({name: 'RepairerJobView', params: {job_id: itm.value}});
              } else {
                this.$router.push({ name: 'RepairerRFQView', params: { rfq_id: itm.value } })
              }
            },
            onEnter() {
              setTimeout(() => {
                let rfq =  _.find(this.additionalMenu, (r) => {
                  return r.isJobView
                })

                if (rfq && !_.isEmpty(this.searchFilter2)) {
                  this.setFilter('')
                  this.$router.push({name: 'RepairerJobView', params: {job_id: rfq.value}});
                  // this.$router.push({ name: 'RepairerRFQView', params: { rfq_id: rfq.id } })
                }
              }, 500)

            },
            isSentRequest(item) {
              let bidders = _.filter(item?.bidders, (b) => {
                return b.status === 'Priced' && b.isSentUpdateRequested
              })
              return !_.isEmpty(bidders)
            },
            changedCurrentPagePriced(value) {
              this.$store.commit('repairer/rfq/repairerRFQPricedCurrentPage', value);
              this.isShowBidders = false
              setTimeout(() => {
                this.isShowBidders = true
              }, 200)
            },
            changedCurrentPageAll(value) {
              this.$store.commit('repairer/rfq/repairerRFQAllCurrentPage', value);
              this.isShowBidders = false
              setTimeout(() => {
                this.isShowBidders = true
              }, 200)
            },
            changedCurrentPageSubmitted(value) {
              this.$store.commit('repairer/rfq/repairerRFQSubmittedCurrentPage', value);
              this.isShowBidders = false
              setTimeout(() => {
                this.isShowBidders = true
              }, 200)
            },
            changedCurrentPageOrdered(value) {
              this.$store.commit('repairer/rfq/repairerRFQOrderedCurrentPage', value);
              this.isShowBidders = false
              setTimeout(() => {
                this.isShowBidders = true
              }, 200)
            },
            getBidderTooltipCached(bidder, item) {
              const rfqId = item?.id
              if (!rfqId || !bidder) {
                return ''
              }

              const key = [
                rfqId,
                bidder.supplier,
                bidder.status,
                bidder.declineReason,
                bidder.isSentUpdateRequested ? 1 : 0,
                bidder.isUpdatedPrices ? 1 : 0,
                item?.isSentAsDirectOrder ? 1 : 0,
              ].join('|')

              const cached = this._bidderTooltipCache[key]
              if (cached != null) {
                return cached
              }

              const title = this.getBidderTooltip(bidder, { item })
              this._bidderTooltipCache[key] = title
              return title
            },
            getBidderTooltip(bidder, data) {
              let r
              if (bidder.status === 'Priced' && bidder.isSentUpdateRequested) {
                r = bidder.supplier + ' ' + '<br /><b>' + 'to be updated' + '</b>'
              } else if (bidder.status == 'Declined' && data.item.isSentAsDirectOrder) {
                r = bidder.supplier + ' ' + '<br /><b>' + 'Declined Direct Order' + '</b>'
              } else if (bidder.status == 'Not Priced') {
                r = bidder.supplier + ' ' + '<br /><b>Not Priced</b>'
              } else {
                r = bidder.supplier + ' ' + '<br /><b>' + bidder.status + '' + '</b>'
              }

              if (bidder.declineReason) {
                r += `<br/> ${bidder.declineReason}`
              }
              return r
            },
            getImageUrl(data) {
              if (data?.item?.pinImage) {
                return data.item.pinImage+'?at='+this.getterAuthToken
              }
              return false
            },
            clickOnAssignedTo (row, u) {
              let user = _.cloneDeep(u);
              if (Number(user.id) === Number(this.currentUser.id)) {
                user.name = this.currentUser.fullName;
              }
              Axios.post('ir/repairer/rfq/' + row.id + '/assign-user', { userId: user.id })
                  .then(response => {
                    if (response.data._status) {
                      this.$store.commit('repairer/rfq/setAssignedUser', { id: row.id, user: user })
                    }
                  })
              this.$refs.menuRFQs.close()
              console.log('clickOnAssignedTo', row, user)
            },
            isBlinkingOrangeIcon(item) {
              let settingsValue = 2

              let time = Number(settingsValue) ? Number(settingsValue) : 10
              let diff = dayjs(item.dateDue).diff(dayjs())
              if (diff <= time * 60 * 1000 && diff >= 0) {
                return true
              }
              return false
            },
            cancelQuote: function (id) {
              Axios.post('/ir/repairer/rfq/' + id + '/cancel', {
                cancelId: id
              }).then(response => {
                this.$toast.success('Quote has been cancelled')
                this.$store.commit('repairer/rfq/repairerRFQUpdateStatus', {id: id, status: 'Cancelled'})
                this.$store.dispatch('repairer/rfq/init', {}, { root: true })
              }).catch(error => {
                this.$toast.error('Quote haven\'t been cancelled')
                console.log(error)
              })
            },
            deleteQuote (id) {
              if (!confirm('Are you sure?')) {
                return
              }
              Axios.post('/ir/repairer/rfq/' + id + '/delete', {
                rfqId: id
              }).then(response => {
                this.$toast.success('Quote has been deleted')
                this.$store.commit('repairer/rfq/repairerRFQDelete', { id: id })
                this.$store.dispatch('repairer/rfq/init', {}, { root: true })
              }).catch(error => {
                this.$toast.error('Quote haven\'t been deleted')
                console.log(error)
              })
              this.$refs.menuRFQs.close()
            },
          viewRFQ (row) {
            this.$router.push({name: 'RepairerRFQView', params: {rfq_id: row.id, isNeedOpenChat: row.hasUnreadMessages}});
            this.$refs.menuRFQs.close();
          },
          openInNewTab (id) {
            window.open(window.location.origin + '/r/rfq/' + id, '_blank')
            this.$refs.menuRFQs.close()
          },
          contextOpen: function (event) {
            this.contextOpenEvent = event
          },
          contextClose: function () {
            this.isOpenSecondContextLevel = false
            let event = this.contextOpenEvent
            if (event) {
              let row = event.target.parentElement
              let rows = row.parentElement.rows
              while (!rows) {
                row = row.parentElement
                rows = row.parentElement.rows
              }
              if (rows) {
                for (let i = 0; i < rows.length; i++) {
                  let elem = rows[i]
                  elem.style.backgroundColor = ''
                }
              }
            }
          },
          openMenuForRFQs (row, index, event) {
            event.preventDefault()
            let tableRow = event.target.parentElement
            let rows = tableRow.parentElement.rows
            while (!rows) {
              tableRow = tableRow.parentElement
              rows = tableRow.parentElement.rows
            }
            if (rows) {
              for (let i = 0; i < rows.length; i++) {
                let elem = rows[i]
                elem.style.backgroundColor = ''
              }
            }
            tableRow.style.backgroundColor = 'rgb(233,248,249)'
            this.$refs.menuRFQs.open(event, { row: row, index: index })
          },
          computedUsersForAssignedFiltered (row) {
            if (!row.assignedTo) {
              return this.computedUsers.slice()
            } else {
              return _.filter(this.computedUsersForAssigned, (user) => {
                return Number(user.id) !== Number(row.assignedTo.id)
              })
            }
          },
            onSearchFilterChange(filters) {
              console.log(filters)
              this.$store.commit('repairer/rfq/repairerSetSearchFilterObj', filters);
              if (filters && filters.search) {
                this._debouncedSetFilter(filters.search);
                // this.filter = filters.search;
              } else {
                this._debouncedSetFilter('');
                // this.filter = '';
              }
              // console.log('onSearchFilterChange', filters);
            },
            onSearchFilterInput() {
            },
            tabChanged (selectedTab) {
            //    console.log('Tab changed to:' + selectedTab.tab.name);
                this.currentTab = selectedTab.tab.name;
                this._saveRfqListUiState()
            },
            filterByPercentRange(percent, percentFrom = 0, percentTo = 25){
                return percent >= percentFrom && percent <= percentTo;
            },
            filterByDatePriced(datePriced = false, hoursFrom = 0, hoursTo = false){
                if(datePriced === false){
                    return false;
                }
                let ct = (Vue.prototype.$http.defaults.headers.common['CompanyTimeOffset'] || 0) * 1;
                let dp = dayjs(datePriced).unix();
                let dn = dayjs().unix();
                dp = Math.floor((dn - dp) / 3600 + ct);
                return dp >= hoursFrom && (!hoursTo || dp <= hoursTo);
            },
            filterByTimeOldRange(datePriced, hoursFrom = 0, hoursTo = 0) {
                //Recently Priced value = number of priced quotes in the last 2 hours
                //1 day old value = number of priced quotes that are from 4 hr to 24 hrs old
                //Over 2 days old value = number of priced quotes that are over 48 hours old.
                const dateFrom = (hoursFrom) ? dayjs().subtract(hoursFrom, 'hour') : dayjs(0)
                const dateTo = dayjs().subtract(hoursTo, 'hour')
                const dp = dayjs(datePriced)
                if (!dp.isValid()) {
                  return false
                }
                return dp.isAfter(dateFrom) && dp.isBefore(dateTo)
            },
            filterTable(row, filter, tabOverride = null) {
                if (!filter) {
                  return true
                }
                let formattedFilter = filter.toLowerCase();
                let percent = parseInt(row.quoteCompletion);
                const tab = tabOverride || this.currentTab
                if (tab === 'Submitted' || tab === 'All') {
                    if (filter === 'upto 25%') return this.filterByPercentRange(percent, 0, 25);
                    else if (filter === 'upto 50%') return this.filterByPercentRange(percent, 26, 50);
                    else if (filter === 'upto 75%') return this.filterByPercentRange(percent, 51, 75);
                }
                if (tab === 'Priced') {
                    if (filter === 'Recently Priced') return this.filterByDatePriced(row.datePriced, 0, 8);
                    else if (filter === '1 day old') return this.filterByDatePriced(row.datePriced, 24, 48);
                    else if (filter === 'Over 2 days old') return this.filterByDatePriced(row.datePriced, 49);
                }

                if (this.isHasFilters) {
                  if (this.isRegoFilterActive && row.rego && _.includes(_.toLower(row.rego), formattedFilter)) {
                    return true;
                  } else if (this.isMakeFilterActive && row.make && _.includes(_.toLower(row.make), formattedFilter)) {
                    return true;
                  } else if (this.isOrderNumberFilterActive && row.orderNumbers && row.orderNumbers.length && _.includes(_.toLower(_.join(row.orderNumbers, ' ')), formattedFilter)) {
                    return true;
                  } else if (this.isQuotingPackageNbrFilterActive && row.QPNumber && _.includes(_.toLower(row.QPNumber), formattedFilter)) {
                    return true;
                  } else if (this.isVINFilterActive && row.vin && _.includes(_.toLower(row.vin), formattedFilter)) {
                    return true;
                  }

                } else {
                  // ADDED (rfqs.vue ~line 944): use Vuex-built search blob for 2000+ rows
                  const blob = this.searchIndexById?.[row.id]
                  if (blob && blob.includes(formattedFilter)) {
                    return true
                  }

                }

                // return _.some(row, v => _.includes(v, filter));
            },
            _applyGlobalFilter(list, tabName) {
              if (!this.filter) {
                return list
              }
              return _.filter(list, (row) => {
                return this.filterTable(row, this.filter, tabName)
              })
            },
            _slicePage(list, currentPage, perPage) {
              const page = Number(currentPage) || 1
              const size = Number(perPage) || 20
              const start = (page - 1) * size
              return list.slice(start, start + size)
            },
            onSortChanged(tabName, ctx) {
              if (!tabName || !ctx) {
                return
              }

              this.$set(this.sortByByTab, tabName, ctx.sortBy || this.sortByByTab[tabName])
              this.$set(this.sortDescByTab, tabName, !!ctx.sortDesc)
            },
            _sortValue(row, key) {
              if (!row || !key) {
                return ''
              }

              if (key === 'assignedTo') {
                return row.assignedTo?.name || ''
              }
              if (key === 'createdBy') {
                return row.createdBy?.name || row.createdBy || ''
              }
              if (key === 'orderNumbers') {
                return Array.isArray(row.orderNumbers) ? row.orderNumbers.join(' ') : (row.orderNumbers || '')
              }
              if (key === 'bidders') {
                return Array.isArray(row.bidders) ? row.bidders.length : 0
              }

              if (key === 'dateReceived' || key === 'dateSubmitted' || key === 'dateDue' || key === 'datePriced') {
                const d = dayjs(row[key])
                return d.isValid() ? d.valueOf() : 0
              }

              const v = row[key]
              return v == null ? '' : v
            },
            _applySort(list, tabName, defaultSortBy, defaultSortDesc) {
              const sortBy = this.sortByByTab?.[tabName] || defaultSortBy
              const sortDesc = this.sortDescByTab?.[tabName]
              const desc = (sortDesc == null) ? !!defaultSortDesc : !!sortDesc

              if (!sortBy) {
                return list
              }

              return _.orderBy(list, [(row) => this._sortValue(row, sortBy)], [desc ? 'desc' : 'asc'])
            },
            clickRFQRow:function (item,index,event) {
                this.$router.push({name: 'RepairerRFQView', params: {rfq_id: item.id, isNeedOpenChat: item.hasUnreadMessages}});
                return;
            },
            clickSubmitQuote() {
                console.log("111", this.$refs['repairer-rfqs-table']);
                console.log("222", this.$refs['repairer-rfqs-table'].activeTabHash);
              if (this.isStatewide){
                this.$router.push({name: 'RfqStatewide'});
              } else if (this.$refs['repairer-rfqs-table'] && this.$refs['repairer-rfqs-table'].activeTabHash && this.$refs['repairer-rfqs-table'].activeTabHash == "#received") {
                    this.$router.push('/r/rfq/add/received');
                } else {
                    this.$router.push({name: 'RepairerRFQAdd'});
                }
                return;
            },
        },
        watch: {
          searchFilter2: {
            handler(value) {
              if (typeof this._debouncedSearchFilter2 === 'function') {
                this._debouncedSearchFilter2(value)
              } else {
                this.searchFilter2Debounced = value
              }
            },
            immediate: true
          },
          sortByByTab: {
            deep: true,
            handler() {
              this.$store.commit('repairer/rfq/repairerRFQAllCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQReceivedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQSubmittedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQPricedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQOrderedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQCancelledCurrentPage', 1)
            }
          },
          sortDescByTab: {
            deep: true,
            handler() {
              this.$store.commit('repairer/rfq/repairerRFQAllCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQReceivedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQSubmittedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQPricedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQOrderedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQCancelledCurrentPage', 1)
            }
          },
          gettersFilter: {
            handler() {
              this.$store.commit('repairer/rfq/repairerRFQAllCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQReceivedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQSubmittedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQPricedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQOrderedCurrentPage', 1)
              this.$store.commit('repairer/rfq/repairerRFQCancelledCurrentPage', 1)
            }
          },
          gettersAllRFQs: {
            handler() {
              this._bidderTooltipCache = {}
            },
            immediate: true
          }
        },
        computed:{
            ...mapGetters({
                isStatewide: 'isStatewide',
                gettersReceivedRFQs: 'repairer/rfq/getReceivedRFQs',
                gettersAllRFQs: 'repairer/rfq/getAllRFQs',
                gettersSubmittedRFQs: 'repairer/rfq/getSubmittedRFQs',
                gettersPricedRFQs: 'repairer/rfq/getPricedRFQs',
                gettersOrderedRFQs: 'repairer/rfq/getOrderedRFQs',
                gettersCancelledRFQs: 'repairer/rfq/getCancelledRFQs',
                gettersFilter: 'repairer/rfq/getFilter',
                // ADDED (rfqs.vue ~line 1040): prebuilt search blob for 2000+ rows
                searchIndexById: 'repairer/rfq/getSearchIndexById',
                getterAllRFQsCurrentPage: 'repairer/rfq/getAllRFQsCurrentPage',
                getterReceivedRFQsCurrentPage: 'repairer/rfq/getReceivedRFQsCurrentPage',
                getterSubmittedRFQsCurrentPage: 'repairer/rfq/getSubmittedRFQsCurrentPage',
                getterPricedRFQsCurrentPage: 'repairer/rfq/getPricedRFQsCurrentPage',
                getterOrderedRFQsCurrentPage: 'repairer/rfq/getOrderedRFQsCurrentPage',
                getterCancelledRFQsCurrentPage: 'repairer/rfq/getCancelledRFQsCurrentPage',
                getterPerPage: 'repairer/rfq/getPerPage',
                getterPerPageAll: 'repairer/rfq/getPerPageAll',
                getterSearchFilterObj: 'repairer/rfq/getSearchFilterObj',
                getterAllUsers: 'users/getAllUsersForAssignedTo',
                getterToken: 'repairer/rfq/getToken',
                currentUser: 'currentUser/getCurrentUserInfo',
                getterSettings: 'settings/getSettings',
                isEstimator: 'currentUser/isEstimator',
              getterAuthToken: 'auth/getAuthToken',
            }),
          additionalMenu() {
              if (_.isEmpty(this.searchFilter2Debounced)) {
                return []
              }
            const q = _.trim(_.toLower(this.searchFilter2Debounced))
            if (!q) {
              return []
            }

            const list = this.gettersAllRFQs || []
            const firstId = list.length ? list[0]?.id : ''
            const lastId = list.length ? list[list.length - 1]?.id : ''
            const cacheKey = `${list.length}:${firstId}:${lastId}`

            if (this._qpIndexCacheKey !== cacheKey || !this._qpIndexCacheValue) {
              this._qpIndexCacheKey = cacheKey
              this._qpIndexCacheValue = _.map(list, (r) => {
                const qp = r.QPNumber || ''
                return {
                  id: r.id,
                  qp,
                  qpLower: _.toLower(_.trim(qp)),
                  rego: r.rego,
                  isSupplement: r.isSupplement,
                  jobViewId: r.jobViewId,
                }
              })

              this._qpIndexCacheValue = _.orderBy(this._qpIndexCacheValue, ['qpLower'], ['asc'])
            }

            // CHANGED (rfqs.vue ~line 1046): binary search by prefix (O(log n + k))
            const arr = this._qpIndexCacheValue
            const lowerBound = (value) => {
              let lo = 0
              let hi = arr.length
              while (lo < hi) {
                const mid = (lo + hi) >> 1
                if ((arr[mid].qpLower || '') < value) lo = mid + 1
                else hi = mid
              }
              return lo
            }

            const start = lowerBound(q)
            const end = lowerBound(q + '\uffff')

            const matches = []
            for (let i = start; i < end; i++) {
              const itm = arr[i]
              if (itm && itm.qpLower && _.startsWith(itm.qpLower, q)) {
                matches.push(itm)
                if (matches.length >= 25) break
              }
            }

            let result = [];
            _.forEach(matches, (itm) => {
              let label = itm.qp
              if (itm.rego) {
                label +=  ' - '
              }

              if (itm.rego) {
                label += itm.rego + ' '
              }

              result.push({
                value: itm.id,
                label: label,
                QPNumber: itm.qp,
                isSupplement: itm.isSupplement,
                jobViewId: itm.jobViewId
              })
            })
            result = _.orderBy(result, ['label'], ['asc']).slice(0, 5)
            let addedJobViewIds=[]
            let jobViewOptions = []
            _.forEach(result, (r) => {
              if (!_.includes(addedJobViewIds, r.jobViewId)) {
                let l = 'JOB VIEW'
                if (r.QPNumber) {
                  l = r.QPNumber + ' - JOB VIEW'
                }
                if (r.isSupplement || r.value != r.jobViewId) {
                  if (result.length == 1) {
                    jobViewOptions.push({
                      value: r.value,
                      label: l,
                      isJobView: true
                    })
                    addedJobViewIds.push(r.jobViewId)
                  }
                } else {
                  jobViewOptions.push({
                    value: r.value,
                    label: l,
                    isJobView: true
                  })
                  addedJobViewIds.push(r.jobViewId)
                }
              }
            })
            _.forEach(jobViewOptions, (j) => {
              let index = _.findIndex(result, (r) => {
                return Number(r.jobViewId) === Number(j.value)
              })
              if (index !== -1) {
                result.splice(index, 0, j)
              }
            })
            return result
          },
          isHasPinImg() {
            return this.getterSettings?.rfq?.tableDisplayPinnedImages?.active && _.some(this.gettersAllRFQs, (rfq) => {
              return rfq.pinImage;
            })
          },
          computedReceivedFields () {
            let fields = this._mapQpLabel(this.receivedFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            return fields
          },
          computedAllFields () {
            let fields = this._mapQpLabel(this.allFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            return fields
          },
          computedSubmittedFields () {
            let fields = this._mapQpLabel(this.submittedFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            return fields
          },
          computedPricedFields () {
            let fields = this._mapQpLabel(this.pricedFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            // if (!this.isEstimator) {
            //   let index = _.findIndex(fields, (f) => {
            //     return f.key === 'bidders'
            //   })
            //   if (index !== -1) {
            //     fields.splice(index, 1)
            //   }
            // }
            return fields
          },
          computedOrderedFields () {
            let fields = this._mapQpLabel(this.orderedFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            return fields
          },
          computedCancelledFields () {
            let fields = this._mapQpLabel(this.cancelledFields.slice());
            if (this.isHasPinImg) {
              fields.unshift(
                  {label: "", key: "images", sortable: false, tdClass: 'clickable number images-block', thClass: ''},
              )
            }
            return fields
          },
          computedUsers () {
            let data = this.getterAllUsers.slice()
            let currUser = _.find(data, (user) => {
              return Number(user.id) === Number(this.currentUser.id);
            });
            if (currUser) {
              currUser.name = 'Me'
              data = _.filter(data, (itm) => {
                return Number(itm.id) !== Number(currUser.id);
              });
              data.unshift({ name: 'Me', id: this.currentUser.id })
            }
            return data
          },
          computedUsersForAssigned () {
            let data = this.getterAllUsers.slice()
            let currUser = _.find(data, (user) => {
              return Number(user.id) === Number(this.currentUser.id);
            });
            data.unshift({ name: 'None', id: null })
            if (currUser) {
              currUser.name = 'Me'
              data = _.filter(data, (itm) => {
                return Number(itm.id) !== Number(currUser.id);
              });
              data.unshift({ name: 'Me', id: this.currentUser.id })
            }
            // if (data) {
            // }
            return data
          },
          computedReceivedRFQs() {
              // CHANGED (rfqs.vue ~line 1157): avoid copying 2000+ rows on each computed recalculation
              let rfqs = this.gettersReceivedRFQs;
              if (this.searchFilterObj.partNumber) {
                let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
                return _.filter(rfqs, rfq => {
                  return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
                })
              }
              return  rfqs;
          },
          computedAllRFQs() {
            // CHANGED (rfqs.vue ~line 1167): avoid copying 2000+ rows on each computed recalculation
            let rfqs = this.gettersAllRFQs;
            if (this.searchFilterObj.partNumber) {
              let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
              return _.filter(rfqs, rfq => {
                return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
              })
            }
            if (this.searchFilterObj.supplier) {
              let formattedFilter = this.searchFilterObj.supplier;
              return _.filter(rfqs, rfq => {
                return rfq.suppliers && rfq.suppliers.includes(formattedFilter)
              })
            }
            return  rfqs;
          },
          filteredAllRFQs() {
            return this._applyGlobalFilter(this.computedAllRFQs, 'All')
          },
          sortedAllRFQs() {
            return this._applySort(this.filteredAllRFQs, 'All', 'dateReceived', true)
          },
          pagedAllRFQs() {
            return this._slicePage(this.sortedAllRFQs, this.getterAllRFQsCurrentPage, this.getterPerPageAll)
          },
          filteredReceivedRFQs() {
            return this._applyGlobalFilter(this.computedReceivedRFQs, 'Received')
          },
          sortedReceivedRFQs() {
            return this._applySort(this.filteredReceivedRFQs, 'Received', 'dateReceived', true)
          },
          pagedReceivedRFQs() {
            return this._slicePage(this.sortedReceivedRFQs, this.getterReceivedRFQsCurrentPage, this.getterPerPage)
          },
          filteredSubmittedRFQs() {
            return this._applyGlobalFilter(this.computedSubmittedRFQs, 'Submitted')
          },
          sortedSubmittedRFQs() {
            return this._applySort(this.filteredSubmittedRFQs, 'Submitted', 'number', true)
          },
          pagedSubmittedRFQs() {
            return this._slicePage(this.sortedSubmittedRFQs, this.getterSubmittedRFQsCurrentPage, this.getterPerPage)
          },
          filteredPricedRFQs() {
            return this._applyGlobalFilter(this.computedPricedRFQs, 'Priced')
          },
          sortedPricedRFQs() {
            return this._applySort(this.filteredPricedRFQs, 'Priced', 'number', true)
          },
          pagedPricedRFQs() {
            return this._slicePage(this.sortedPricedRFQs, this.getterPricedRFQsCurrentPage, this.getterPerPage)
          },
          filteredOrderedRFQs() {
            return this._applyGlobalFilter(this.computedOrderedRFQs, 'Ordered')
          },
          sortedOrderedRFQs() {
            return this._applySort(this.filteredOrderedRFQs, 'Ordered', 'number', true)
          },
          pagedOrderedRFQs() {
            return this._slicePage(this.sortedOrderedRFQs, this.getterOrderedRFQsCurrentPage, this.getterPerPage)
          },
          filteredCancelledRFQs() {
            return this._applyGlobalFilter(this.computedCancelledRFQs, 'Cancelled')
          },
          sortedCancelledRFQs() {
            return this._applySort(this.filteredCancelledRFQs, 'Cancelled', 'number', true)
          },
          pagedCancelledRFQs() {
            return this._slicePage(this.sortedCancelledRFQs, this.getterCancelledRFQsCurrentPage, this.getterPerPage)
          },
          sortByAll() { return this.sortByByTab?.All || 'dateReceived' },
          sortDescAll() { return (this.sortDescByTab?.All ?? true) },
          sortByReceived() { return this.sortByByTab?.Received || 'dateReceived' },
          sortDescReceived() { return (this.sortDescByTab?.Received ?? true) },
          sortBySubmitted() { return this.sortByByTab?.Submitted || 'number' },
          sortDescSubmitted() { return (this.sortDescByTab?.Submitted ?? true) },
          sortByPriced() { return this.sortByByTab?.Priced || 'number' },
          sortDescPriced() { return (this.sortDescByTab?.Priced ?? true) },
          sortByOrdered() { return this.sortByByTab?.Ordered || 'number' },
          sortDescOrdered() { return (this.sortDescByTab?.Ordered ?? true) },
          sortByCancelled() { return this.sortByByTab?.Cancelled || 'number' },
          sortDescCancelled() { return (this.sortDescByTab?.Cancelled ?? true) },
          computedSubmittedRFQs() {
            // CHANGED (rfqs.vue ~line 1183): avoid copying 2000+ rows on each computed recalculation
            let rfqs = this.gettersSubmittedRFQs;
            if (this.searchFilterObj.partNumber) {
              let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
              return _.filter(rfqs, rfq => {
                return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
              })
            }
            if (this.searchFilterObj.supplier) {
              let formattedFilter = this.searchFilterObj.supplier;
              return _.filter(rfqs, rfq => {
                return rfq.suppliers && rfq.suppliers.includes(formattedFilter)
              })
            }
            return  rfqs;
          },
          computedPricedRFQs() {
            // CHANGED (rfqs.vue): avoid copying 2000+ rows on each computed recalculation
            let rfqs = this.gettersPricedRFQs;
              if (this.searchFilterObj.partNumber) {
                let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
               rfqs =  _.filter(rfqs, rfq => {
                  return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
                })
              }
            if (this.searchFilterObj.supplier) {
              let formattedFilter = this.searchFilterObj.supplier;
              rfqs =  _.filter(rfqs, rfq => {
                return rfq.suppliers && rfq.suppliers.includes(formattedFilter)
              })
            }

            let rfqRequestedUpdated = _.filter(rfqs, (r) => {
              return this.isSentRequest(r)
            })
            let rfqNotRequestedUpdated = _.filter(rfqs, (r) => {
              return !this.isSentRequest(r)
            })
            return rfqRequestedUpdated.concat(rfqNotRequestedUpdated)
          },
          computedOrderedRFQs() {
                // CHANGED (rfqs.vue ~line 1229): avoid copying 2000+ rows on each computed recalculation
                let rfqs = this.gettersOrderedRFQs;
              if (this.searchFilterObj.partNumber) {
                let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
                return _.filter(rfqs, rfq => {
                  return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
                })
              }
            if (this.searchFilterObj.supplier) {
              let formattedFilter = this.searchFilterObj.supplier;
              return _.filter(rfqs, rfq => {
                return rfq.suppliers && rfq.suppliers.includes(formattedFilter)
              })
            }
              return  rfqs;
          },
          computedCancelledRFQs() {
                // CHANGED (rfqs.vue ~line 1245): avoid copying 2000+ rows on each computed recalculation
                let rfqs = this.gettersCancelledRFQs;
              if (this.searchFilterObj.partNumber) {
                let formattedFilter = this.searchFilterObj.partNumber.toLowerCase();
                return _.filter(rfqs, rfq => {
                  return rfq.partsNumbers && _.includes(_.toLower(rfq.partsNumbers), formattedFilter)
                })
              }
            if (this.searchFilterObj.supplier) {
              let formattedFilter = this.searchFilterObj.supplier;
              return _.filter(rfqs, rfq => {
                return rfq.suppliers && rfq.suppliers.includes(formattedFilter)
              })
            }
              return  rfqs;
          },
          filter: {
            get() {
              return this.gettersFilter;
            },
            set (value) {
              this.setFilter(value);
            }
          },
          computedToken() {
            return this.getterToken;
          },
            isRegoFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('rego'));
            },
            isMakeFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('make'));
            },
            isVINFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('vin'));
            },
            isOrderNumberFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('orderNumber'));
            },
          isPartNumberFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('partNumber'));
            },
          isSupplierFilterActive() {
            return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('supplier'));
          },
            isQuotingPackageNbrFilterActive() {
              return !!(this.searchFilterObj && this.searchFilterObj.hasOwnProperty('quotingPackageNbr'));
            },
            isHasFilters() {
              return this.isRegoFilterActive || this.isMakeFilterActive || this.isVINFilterActive || this.isOrderNumberFilterActive || this.isQuotingPackageNbrFilterActive;
            },
            computedSearchFilters() {
              const list = this.gettersAllRFQs || []
              const firstId = list.length ? list[0]?.id : ''
              const lastId = list.length ? list[list.length - 1]?.id : ''
              const key = `${list.length}:${firstId}:${lastId}:${this.currentTab}`

              if (this._searchFiltersCacheKey === key && this._searchFiltersCacheValue) {
                return this._searchFiltersCacheValue
              }

              let partNumbers = {}
              let suppliers = {}

              list.forEach(rfq => {
                if (rfq.partsNumbers) {
                  let numbers = rfq.partsNumbers.split(';');
                  _.forEach(numbers, n => {
                    partNumbers[n.toLowerCase().trim()] = { label: n.toLowerCase().trim() }
                  })
                }
                if (rfq.suppliers) {
                  _.forEach(rfq.suppliers, s => {
                    suppliers[s.toLowerCase().trim()] = { label: s.trim() }
                  })
                }

              });

              partNumbers = _.orderBy(Object.values(partNumbers), [(itm) => itm.label.toLowerCase().trim()], ["asc"]);
              suppliers = _.orderBy(Object.values(suppliers), [(itm) => itm.label.toLowerCase().trim()], ["asc"]);

              // Create date template
              const date = [
                {
                  id: 'date',
                  label: "Date",
                  resultObjectOnly: true,
                  type: "Date",
                  iconClass: "bx-calendar"
                }
              ];

              // Create searchFilter filters
              let r = [
                {
                  id: 'partNumber',
                  label: 'Part Number',
                  iconClass: 'bx-user',
                  options: [
                    partNumbers,
                  ]
                },
                {
                  id: 'make',
                  label: 'Make',
                  iconClass: 'bx-user',
                  options: []
                },
                {
                  id: 'rego',
                  label: 'Rego',
                  iconClass: 'bx-user',
                  options: []
                },
                {
                  id: 'vin',
                  label: 'VIN',
                  iconClass: 'bx-user',
                  options: []
                },
                {
                  id: 'orderNumber',
                  label: 'Order Number',
                  iconClass: 'bxs-user-badge',
                  options: []
                },
                {
                  id: 'quotingPackageNbr',
                  label: 'Quoting Package Nbr',
                  iconClass: 'bx-car',
                  options: []
                },
              ];
              if (this.currentTab !== 'Received') {
                r.push({
                  id: 'supplier',
                  label: 'Suppliers',
                  iconClass: 'bx-car',
                  options: [
                    suppliers,
                  ]
                },)
              }

              this._searchFiltersCacheKey = key
              this._searchFiltersCacheValue = r
              return r
            },
            searchFilterObj() {
              return this.getterSearchFilterObj;
            },
            computedTotalCounts() {
              let counts = {
                all: 0,
                received: 0,
                submitted: 0,
                priced: 0,
                ordered: 0,
                cancelled: 0,
              }
              counts.all = this.gettersAllRFQs.length;
              counts.received = this.gettersReceivedRFQs.length;
              counts.submitted = this.gettersSubmittedRFQs.length;
              counts.priced = this.gettersPricedRFQs.length;
              counts.ordered = this.gettersOrderedRFQs.length;
              counts.cancelled = this.gettersCancelledRFQs.length;
              return counts;
            },
            isReceivedTabActive() {
                this.$nextTick(() => {
                    if (this.$refs['repairer-rfqs-table'] && this.$refs['repairer-rfqs-table'].activeTabHash && this.$refs['repairer-rfqs-table'].activeTabHash == "#received") {
                        return true;
                    }
                });
                return false;
            },
        },
        mounted() {
            const hasRouteTab = !!this.$route.params.activeTab
            if(this.currentTab === 'All' || this.currentTab === 'Submitted' || this.currentTab === 'Priced') {
              let filter = this.$route.query.filter;
              if (filter) {
                this.setFilter(filter);
              }
            }
            console.log('mounted');
            if (this.$route.params.activeTab) {
              this.$refs["repairer-rfqs-table"].selectTab(this.$route.params.activeTab)
              return
            }

            const st = this._restoreRfqListUiState()
            if (!hasRouteTab && st && st.activeTabId && this.$refs["repairer-rfqs-table"]) {
              this.$refs["repairer-rfqs-table"].selectTab(st.activeTabId)
            }
        },
        beforeRouteLeave(to, from, next) {
          this._saveRfqListUiState()
          next()
        },
        beforeDestroy() {
            this._saveRfqListUiState()
            if (this._debouncedSetFilter && this._debouncedSetFilter.cancel) {
                this._debouncedSetFilter.cancel()
            }
            if (this._debouncedSearchFilter2 && this._debouncedSearchFilter2.cancel) {
                this._debouncedSearchFilter2.cancel()
            }
        },
        components: {
            notificationOnTable,
            BlockPagination,
            VueContext,
            SearchFilter,
        }
    };
</script>

<style scoped>
  .users-context-level {
    position: absolute;
    border: 1px solid #bdbdbd;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    background: white;
    left: 138px;
    top: 84px;
    width: 170px;
    max-height: 400px;
    overflow-y: auto;
  }
  @media (max-width: 768px) {
    .V3 .ps-mobile-view .page-header {
      min-height: 119px;
    }
  }
</style>

<style>
.theme-repairer .repairer-rfqs-page .table .notification-column {
  min-width: 130px !important;
}
</style>
